import React, { useEffect, useState, useRef } from 'react';
import { Button, CommonAgreeLayer } from 'components'
import useApp from 'hooks/useApp'
import styles from '../index.module.css'
import useCertifications from 'hooks/useCertifications'
import { dataDetailTerms2Info } from './TermsInformations'
import { checkedResultDataState, certFromState, certTypeState, selectedOrgsState } from '../states'
import { manageCheckedResultOrgsState, consentListState } from 'views/mydata/manage/states'
import { useRecoilValue, useRecoilState } from 'recoil'
import Lib from 'library'


const DataDetailTerms2 = () => {

	const App = useApp()
	const mounted = useRef(false)
	const [showTermsLayer, setShowTermsLayer] = useState(false)
	const [showNaverTermsLayer, setShowNaverTermsLayer] = useState(false)
	const core = useRef()
	const [buttonText, setButtonText] = useState("아래로 내려보기")
	const [atBottom, setAtBottom] = useState(false)
	const { goCommonCert, goNaverCert, goIndividualCert } = useCertifications()
	const certFrom = useRecoilValue(certFromState)
	const [selectedOrgs, setSelectedOrgs] = useRecoilState(certFrom === "extend" || certFrom === "modify" ? manageCheckedResultOrgsState : selectedOrgsState)
	const checkedResultData = useRecoilValue(certFrom === "extend" || certFrom === "modify" ? selectedOrgsState : checkedResultDataState)
	const [industries, setIndustries] = useState([])
	const certType = useRecoilValue(certTypeState)
	const consentList = useRecoilValue(consentListState)

	const bindScroll = () => {
		setTimeout(() => {
			if (core.current.clientHeight >= core.current.scrollHeight - 30) {
				mounted.current && setAtBottom(true)
			}
		}, 500)
		core.current.addEventListener("scroll", e => {
			const clientHeight = core.current.clientHeight
			const scrollHeight = core.current.scrollHeight
			const scrollTop = core.current.scrollTop
			if (!mounted.current) return
			if (clientHeight + scrollTop >= scrollHeight - 30) {
				setAtBottom(true)
			} else {
				setAtBottom(false)
			}
		})
	}

	const onAgree = () => {
		setShowTermsLayer(false);
		goCommonCert()
	}

	const onNaverAgree = () => {
		setShowNaverTermsLayer(false);
		goNaverCert()
	}

	const onNext = () => {
		if (atBottom) {
			switch (certType) {
				case 0: // 공동인증
					if (certFrom === "extend" || certFrom === "modify") {
						goCommonCert()
					} else {
						setShowTermsLayer(true)
					}
					break
					case 1: // 네이버인증
					if (certFrom === "extend" || certFrom === "modify") {
						goNaverCert()
					} else {
						setShowNaverTermsLayer(true)
					}
					break
				case 2: // 사설인증
					goIndividualCert()
					break
			}
		} else {
			const scrollTop = core.current.scrollTop
			const pageHeight = document.body.scrollHeight
			core.current.scrollTo(0, (scrollTop + pageHeight) * 0.8)
		}
	}

	useEffect(() => {
		if (checkedResultData) {
			const newIndustries = []
			const newOrgs = []
			checkedResultData.forEach(org => {
				if (!newIndustries.some(industry => industry === org.indstCd)) newIndustries.push(org.indstCd)

				if (!newOrgs.some(orgName => orgName === org.insttNm)) {
					// object로 사용하다가 string으로 상태를 set함으로 인해 화면 뒤로가기 시 object로 사용하는 화면에서 에러 발생하여 수정
					// newOrgs.push(org.insttNm)
					newOrgs.push(org)
				}
			})
			if (certFrom !== "extend" && certFrom !== "modify") setSelectedOrgs(newOrgs)
			setIndustries(newIndustries)
		}
	}, [checkedResultData])


	useEffect(() => {
		if (atBottom) {
			setButtonText("동의하기")
		} else {
			setButtonText("아래로 내려보기")
		}
	}, [atBottom])
	useEffect(() => {
		console.log('selectedOrgs >>> ', selectedOrgs)
	}, [selectedOrgs])

	useEffect(() => {
		mounted.current = true
		App.setHeader({
			show: true,
			title: <></>,
			left: undefined,
			right: undefined
		})

		core.current = document.querySelector(".core")
		mounted.current && bindScroll()

		App.setShowNav(false)
		App.setMainClass("white")

		console.log({selectedOrgs})
		console.log({checkedResultData})
		console.log({industries})

		if(checkedResultData.length < 1 ){
			// checkedResultData가 없는 경우에 selectedOrgs가 셋팅되지않아 정보제공자 부분 공란으로 표기되는 오류 확인
			setSelectedOrgs(selectedOrgs)
		}
		return () => mounted.current = false
	}, [])

	return (
		<div className="page">
			<div className="padding flex_1">
				<div className={styles["count-group"]}>
					<p>전송요구 및 정보 제공 동의</p>
					<div><span>2</span>/3</div>
				</div>
				<div className={`${styles["terms-area"]} mt_40 pb_100`}>
					<p>상세정보 전송요구서 및 개인(신용) 정보 수집 ・ 이용 동의서(상세정보전송)</p>
					<span className="mt_10">
						핀테크는 ⌜신용정보의 이용 및 보호에 관한 법률⌟, ⌜개인정보 보호법⌟등 관련 법령에 따라 다음과 같이 귀하의 개인(신용)정보를 처리합니다.
					</span>
					<ul className="mt_40">
						<li>
							<div>거부 권리 및 불이익</div>
							<span className="mt_10">
								귀하는 개인(신용)정보 수집 ・ 이용에 관한 동의를 거부하실 수 있습니다. 다만, “필수 항목에 대한 수집 ・ 이용에 관한 동의”는 본인신용 정보 통합조회, 데이터분석 서비스의 이용을 위한 필수적 사항이므로 동의를 거부하실 경우 본인신용정보 통합조회, 데이터분석 서비스의 이용이 제한될 수 있으며, “선택 항목에 대한 수집 ・ 이용에 관한 동의”는 거부하실 경우 해당 선택 항목에 대한 본인신용정보통합조회, 데이터분석 서비스의 이용이 제한될 수 있습니다.
							</span>
						</li>
						<li>
							<div>정보제공자</div>
							<span className="mt_10">
								{
									selectedOrgs &&
									selectedOrgs.map((orgName, index) => {
										return <span className={index > 0 ? "ml_5" : undefined} key={index}>{(() => {
											if (typeof orgName === "string") {
												return orgName
											} else {
												return orgName.insttNm
											}
										})()}{index < selectedOrgs.length - 1 &&
											", " + orgName.insttNm}
											</span>
									})
								}
							</span>
						</li>
						<li>
							<div>개인(신용)정보를 제공받는자</div>
							<span className="mt_10">
								{App.comName}
							</span>
						</li>
						<li>
							<div>전송요구 및 수집 ・ 이용 목적</div>
							<span className="mt_10">
								전송요구를 통한 본인신용정보 통합조회, 데이터분석 서비스의 이용
							</span>
						</li>
						<li>
							<div>보유 및 이용기간</div>
							<p className="text-blue mt_10">서비스 이용 종료 시 또는 삭제 요구 시까지</p>
						</li>
						<li>
							<div>전송을 요구하는 개인(신용)정보(수집 ・ 이용 항목)</div>
							<div className={styles.category}>
								<div>
									<p>개인(식별)정보</p>
									<span>・ 전자서명, 접근토큰, 인증서, 전송요구서</span>
								</div>
							</div>
							<div className={styles.category}>
								<div>
									<p>개인(신용)거래정보</p>
									<div className="pl_10">
										{
											(industries && industries.length > 0) &&
											industries.map((item, index) => {
												return (
													<div key={index} className={index > 0 ? "mt_10" : undefined}>
														<div className="bold">{dataDetailTerms2Info[item].name}</div>
														<span style={{ whiteSpace: "pre-line", wordBreak: "break-all" }}>{dataDetailTerms2Info[item].data}</span>
													</div>
												)
											})
										}
									</div>
								</div>
							</div>
						</li>
					</ul>
					<p className="mt_30">위와 같은 전송요구 및 개인(신용)정보 수집 ・ 이용에 동의하십니까?</p>
				</div>
			</div>
			{/* 스크롤 끝 까지 내려가면 가이드 텍스트 사라지고 버튼명 동의하기로 변경 */}
			<div className={`${styles["floating-btn"]} padding`}>
				<div className="flex-justify_center mb_20">
					<span className={styles.guide}><i className="icon icon_floating_arrow_down mr_5" />끝까지 확인하고 동의하기</span>
				</div>
				<Button className="btn btn--big" onClick={onNext}>{buttonText}</Button>
			</div>

			{/* <TermsLayer show={termsLayer} closeTerms={closeTerms} /> */}
			<CommonAgreeLayer title="공동인증서 인증을 위해 동의가 필요해요." buttonText="모두 동의하고 진행하기" show={showTermsLayer} closeLayer={() => setShowTermsLayer(false)} onAgree={onAgree} termsCategoryCd="CRTFCN" />
			<CommonAgreeLayer title="네이버 인증 필수 동의" show={showNaverTermsLayer} closeLayer={() => setShowNaverTermsLayer(false)} onAgree={onNaverAgree} termsCategoryCd="NAVER_TERMS" />
		</div>
	)
}

export default DataDetailTerms2